import Index from './index.vue'

const basePath = '/v-agency/job-list'

export default {
  name: 'agencyJobList',
  path: `${basePath}`,
  component: Index,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.job.list.title'
  }
}
